import React, { useState, useEffect } from 'react'
import { XMarkIcon } from '@heroicons/react/24/outline'
import { apiService } from '../services/apiService'
import toast from 'react-hot-toast'

const CancellationReasonForm = ({ cancellationReason, onClose, onSuccess }) => {
  const [formData, setFormData] = useState({
    name: '',
    description: '',
    applies_to: 'contract',
    requires_approval: false
  })
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (cancellationReason) {
      setFormData({
        name: cancellationReason.name || '',
        description: cancellationReason.description || '',
        applies_to: cancellationReason.applies_to || 'contract',
        requires_approval: cancellationReason.requires_approval || false
      })
    }
  }, [cancellationReason])

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }))
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setLoading(true)

    try {
      let result
      if (cancellationReason) {
        result = await apiService.updateCancellationReason(cancellationReason.id, formData)
      } else {
        result = await apiService.createCancellationReason(formData)
      }

      toast.success(
        cancellationReason
          ? 'Motivo de cancelamento atualizado com sucesso!'
          : 'Motivo de cancelamento criado com sucesso!'
      )
      onSuccess()
    } catch (error) {
      console.error('Erro ao salvar motivo de cancelamento:', error)
      toast.error('Erro ao salvar motivo de cancelamento')
    } finally {
      setLoading(false)
    }
  }

  const appliesOptions = [
    { value: 'contract', label: 'Contrato' },
    { value: 'payment', label: 'Pagamento' },
    { value: 'service', label: 'Serviço' },
    { value: 'maintenance', label: 'Manutenção' }
  ]

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white dark:bg-gray-800 rounded-xl shadow-xl max-w-2xl w-full max-h-[90vh] overflow-y-auto">
        <div className="flex justify-between items-center p-6 border-b border-gray-200 dark:border-gray-700">
          <h2 className="text-xl font-semibold text-gray-900 dark:text-white">
            {cancellationReason ? 'Editar Motivo de Cancelamento' : 'Novo Motivo de Cancelamento'}
          </h2>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 dark:hover:text-gray-300 transition-colors"
          >
            <XMarkIcon className="w-6 h-6" />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="p-6 space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
              Nome *
            </label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
              className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 dark:bg-gray-700 dark:text-white"
              placeholder="Nome do motivo de cancelamento"
            />
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                Aplica-se a *
              </label>
              <select
                name="applies_to"
                value={formData.applies_to}
                onChange={handleChange}
                required
                className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 dark:bg-gray-700 dark:text-white"
              >
                {appliesOptions.map(option => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </select>
            </div>

            <div className="flex items-center">
              <input
                type="checkbox"
                name="requires_approval"
                id="requires_approval"
                checked={formData.requires_approval}
                onChange={handleChange}
                className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
              />
              <label htmlFor="requires_approval" className="ml-2 block text-sm text-gray-700 dark:text-gray-300">
                Requer aprovação
              </label>
            </div>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
              Descrição
            </label>
            <textarea
              name="description"
              value={formData.description}
              onChange={handleChange}
              rows={3}
              className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 dark:bg-gray-700 dark:text-white"
              placeholder="Descrição do motivo de cancelamento..."
            />
          </div>

          <div className="flex justify-end space-x-3 pt-4">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 text-gray-700 dark:text-gray-300 border border-gray-300 dark:border-gray-600 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors"
            >
              Cancelar
            </button>
            <button
              type="submit"
              disabled={loading}
              className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 focus:ring-2 focus:ring-blue-500 disabled:opacity-50 transition-colors"
            >
              {loading ? 'Salvando...' : cancellationReason ? 'Atualizar' : 'Criar'}
            </button>
          </div>
        </form>
      </div>
    </div>
  )
}

export default CancellationReasonForm